"use client";

import Image from "next/image";
import Link, { useLinkStatus } from "next/link";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import type { ReactNode } from "react";

import { AppLinkProvider } from "@/ui/app-link/app-link";
import type {
  AppImageProps,
  AppLinkAdapter,
  AppLinkProps,
} from "@/ui/app-link/types";

function NextLink(props: AppLinkProps) {
  return <Link {...props} />;
}

function NextImage(props: AppImageProps) {
  return <Image {...props} />;
}

const nextAdapter: AppLinkAdapter = {
  Link: NextLink,
  Image: NextImage,
  useRouter,
  usePathname,
  useSearchParams,
  useLinkPending: useNextLinkPending,
};

function useNextLinkPending(): boolean {
  return useLinkStatus().pending;
}

/** Mount once at a Next app's root, above every shared component. */
export function NextAppLinkProvider(props: { children: ReactNode }) {
  return (
    <AppLinkProvider adapter={nextAdapter}>{props.children}</AppLinkProvider>
  );
}
